import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Webhooks20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_953)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25C4.61522 0.25 0.25 4.61522 0.25 10C0.25 15.3848 4.61522 19.75 10 19.75ZM10 1.75C8.68756 1.75 8.16357 5.41613 8.03108 6.25H11.9689C11.8364 5.41613 11.3124 1.75 10 1.75ZM6.5136 6.25H2.64956C3.67805 4.23808 5.50828 2.7041 7.7189 2.06941C7.04839 3.35758 6.724 4.82461 6.5136 6.25ZM6.34184 7.75H2.06055C1.64685 9.21268 1.64685 10.7873 2.06055 12.25H6.34184C6.22145 10.8037 6.22145 9.19627 6.34184 7.75ZM6.5136 13.75H2.64956C3.67805 15.7619 5.50828 17.2959 7.7189 17.9306C7.04839 16.6424 6.724 15.1754 6.5136 13.75ZM8.03108 13.75H11.9689C11.8364 14.5839 11.3124 18.25 10 18.25C8.68756 18.25 8.16357 14.5839 8.03108 13.75ZM12.1526 12.25H7.84735C7.71502 10.7551 7.71502 9.24488 7.84735 7.75H12.1526C12.285 9.24488 12.285 10.7551 12.1526 12.25ZM13.4864 13.75C13.276 15.1754 12.9516 16.6424 12.2811 17.9306C14.4917 17.2959 16.322 15.7619 17.3504 13.75H13.4864ZM17.9395 12.25H13.6582C13.7785 10.8037 13.7785 9.19627 13.6582 7.75H17.9395C18.3531 9.21269 18.3531 10.7873 17.9395 12.25ZM12.2811 2.06941C14.4917 2.7041 16.322 4.23808 17.3504 6.25H13.4864C13.276 4.82461 12.9516 3.35758 12.2811 2.06941Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_953'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Webhooks20.displayName = 'Webhooks20';
export default Webhooks20;
